import React from 'react';
import PropTypes from 'prop-types';
import s from './Flag.module.scss';
import 'flag-icons/css/flag-icons.min.css';
import classNames from 'classnames';

const Flag = ({ countryCode = '', width = '3rem', isSquare = false }) => {
    const countryCodeLowerCase = countryCode.toLowerCase();
    const classes = classNames(
        s.Root,
        `fi fi-${countryCodeLowerCase} ${isSquare ? 'fis' : ''}`,
        { [s['Root--Square']]: isSquare }
    );

    return (
        <span
            className={classes}
            style={{ maxWidth: width, minWidth: width }}></span>
    );
};

Flag.propTypes = {
    countryCode: PropTypes.string.isRequired,
    width: PropTypes.string,
    isSquare: PropTypes.bool,
};

export default Flag;
